/*global $:false*/

import tmpl_dialog_confirm from '../templates/dialog-confirm.dot';
import tmpl_dialog_info from '../templates/dialog-info.dot';
import tmpl_dialog_selection from '../templates/dialog-selection.dot';

// view that will show a confirm dialog
//
// confs:
//
// * `message`: the confirmation message
// * `confirmBtnLabel: The label that appear in the confirmation button
// * `confirmBtnClass: add classes to the confirmation button
//
// callbacks:
//
//  * `requestConfirmed`: Continue the request. The user has confirmed
//  * `requestCancelled`: An optional Cancel CallBack to execute when the user cancels
//
var ConfirmDialog = function(core, confs, callbacks) {

    var _$confirmDialog = $(tmpl_dialog_confirm(confs));

    _$confirmDialog.on("click", ".js-confirm", function() {
        if (callbacks.requestConfirmed) {
            callbacks.requestConfirmed();
        }
        _$confirmDialog.modal("hide");
    });

    _$confirmDialog.on("click", ".js-cancel", function() {
        if (callbacks.requestCancelled) {
            callbacks.requestCancelled();
        }
        _$confirmDialog.modal("hide");
    });

    _$confirmDialog.on("hidden", function() {
        _$confirmDialog.remove();
    });

    _$confirmDialog.modal({show: true, cobAppInstanceId: core.getAppInstanceId()});

};

// view that will show a information dialog
//
// confs:
//
// * `title`: the information message
// * `message`: the information message
// * `closeBtnLabel: The label that appear in the close button
var InfoDialog = function(core, confs, callbacks) {

    var _dialog = $(tmpl_dialog_info(confs));

    _dialog.on("click", ".js-close", function() {
        _dialog.modal("hide");
    });

    _dialog.on("hidden", function() {
        _dialog.remove();
    });

   if (callbacks && callbacks.onClose) {
      _dialog.on("hidden", callbacks.onClose );
   }

    _dialog.modal({
       keyboard: true,
       show: true,
       cobAppInstanceId: core.getAppInstanceId()}
    );
};


// view that will show a checkbox list dialog with the items provided
//
// confs:
//
// * `title`: a title for the dialog
// * `startSelected: flag to indicate if the items should be started as all selected
// * `confirmBtnLabel: The label that appear in the confirmation button
// * `confirmBtnClass: add classes to the confirmation button
// * `items`: an array with the items to create the checkbox list from; each item must have a value and name attribute
//
// callbacks:
//
//  * `requestConfirmed`: called when confirm button clicked (passes selected checkbox values selected as arg)
//
var SelectionDialog = function(core, confs, callbacks) {
    var _$dialog = $(tmpl_dialog_selection(confs));


    var _getSelectedItems = function() {
        var selectedValues = [];

        _$dialog.find("input[type='checkbox']").each(
            function(index, element) {
                var _$el = $(element);
                if (_$el.is(":checked")) {
                    selectedValues.push(_$el.val());
                }
            });

        return selectedValues;
    };

    _$dialog.find(".selection-dialog-item").each(function(idx,el){
        var _$el = $(el);

        _$el.click(function() {
            var isSelected = _$el.children("input[type='checkbox']").is(':checked');
            _$el.toggleClass("selected", isSelected);
        });
    });

    _$dialog.on("click", ".js-confirm", function() {
        if (callbacks.requestConfirmed) {
            callbacks.requestConfirmed(_getSelectedItems());
        }
        _$dialog.modal("hide");
    });

    _$dialog.on("hidden", function() {
        _$dialog.remove();
    });

    _$dialog.modal({show: true, cobAppInstanceId: core.getAppInstanceId()});
};

export { ConfirmDialog, InfoDialog, SelectionDialog };
